import React from 'react'
import {
  List,
  ListItem,
} from 'material-ui/List'
import renderContent from '../../utilities/renderContent'
import './style.css'
import { Parallax } from 'react-parallax';
import {
  Link,
} from 'react-router-dom'

const ProductList = ({ products }) => {
  // console.log('Product.products'. products)

  return (
    <div className="products">
      <div className="container">
        <div className="content">
          <h1 className="title">Products</h1>
          <div className="list-wrapper">
            <List>
              {
                Object.keys(products).map((key) => {
                  const product = products[key]

                  return (
                    <Link to={`/products/${key}`} key={key}>
                      <ListItem primaryText={product.name} />
                    </Link>
                  )
                })
              }
            </List>
          </div>
        </div>
      </div>
    </div>
  )
}

const Product = ({ products }) => {
  console.log('Products.products', products)
  var image_dom = null;
  if (products.images != undefined){
    image_dom = products.images.map(function(image, key){
        return (
          <img src={image}
            className="image-product"
            draggable="false"
            alt={products.name}
            key={key}
          />
        )
      }
    )
  }
  return (
    <div className="product">
      <div className="page-bg">
        <Parallax bgImage="../images/products/00.jpg" strength={150} className="page-parallax">
        </Parallax>
      </div>
      <div className="container container-parallax">
        <div className="parallax-container">
          <div className="content">
            <div className="left">
              {image_dom}
            </div>
            <div className="right">
              <div className="product-title">{products.name}</div>
              {renderContent(products.content)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Products = ({ data, match }) => {
  if (match && match.params.productId !== undefined && data.products[match.params.productId] !== undefined) {
    return <Product products={data.products[match.params.productId]} />
  } else {
    return <ProductList products={data.products} />
  }
}

export default Products



// WEBPACK FOOTER //
// ./src/components/Products/index.js